import { useCallback, useEffect, useRef, useState } from 'react';

const AUTO_COLLAPSE_ON_COMPLETED_DELAY = 4000;

export const useBuilderCollapse = ({ alwaysOpen, completed }) => {
  const [collapsed, setCollapsed] = useState(completed && !alwaysOpen);
  const timerRef = useRef(null);

  if (collapsed && !completed && !alwaysOpen) {
    setCollapsed(false);
  }

  useEffect(() => {
    if (alwaysOpen) {
      return () => {};
    }

    // If not complete then avoid collapse logic altogether.
    if (!completed) {
      return () => {};
    }

    // Handle the deferred collapse when it is completed.
    timerRef.current = setTimeout(() => {
      setCollapsed(true);
    }, AUTO_COLLAPSE_ON_COMPLETED_DELAY);

    return () => {
      clearTimeout(timerRef.current);
    };
  }, [alwaysOpen, completed]);

  const onClick = useCallback(() => {
    clearTimeout(timerRef.current);
    setCollapsed(previousState => !previousState);
  }, []);

  return {
    collapsed,
    onClick,
  };
};
